function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, memo, MouseEventHandler } from 'react';
import cn from 'classnames';
require("./ArrowButton.css");
var styles = {
  "Root": "ArrowButton-module-Root_2-0",
  "hidden": "ArrowButton-module-hidden_3OR",
  "direction_right": "ArrowButton-module-direction_right_38G",
  "direction_left": "ArrowButton-module-direction_left_1tU"
};
export const ArrowButton = /*#__PURE__*/memo(({
  arrowsAlignHeight,
  direction,
  visible,
  className,
  onClick,
  ...props
}) => {
  const style = arrowsAlignHeight ? {
    top: Math.round(arrowsAlignHeight / 2)
  } : undefined;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.Root, styles[`direction_${direction}`], {
      [styles.hidden]: !visible
    }, className),
    onClick: onClick,
    style: style
  }, props));
});